import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

@Component({
  selector: 'bmcore-new-password-page',
  templateUrl: './bmcore-new-password-page.component.html',
  styleUrls: ['./bmcore-new-password-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreNewPasswordPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
